import style from './list-key-points.scss';
import inView from 'in-view';
import timing from './../../../design-system/motion/timing';
import PerfectScrollbar from 'perfect-scrollbar';
import listKeys from 'Assets/js/list-key-behavior';

const script = () => {
  const cssClass: string = 'ListKeyPoints';
  const target: string = `.${cssClass}`;
  const targets: any = document.querySelectorAll(target);

  listKeys({
    cssClass: `.${cssClass}`,
    titleClass: '.BlockKeyPoint-title',
  });

  for (const elt of targets) {

    // test if element is init
    if (elt.dataset[`init${cssClass}`]) {
      return true; // already init go to next iteration
    }
    // init element
    elt.dataset[`init${cssClass}`] = true;

    // Add scrollbar on inlined version only
    if (elt.classList.contains(`${cssClass}--inlined`)) {
      const container = elt.querySelector(`.${cssClass}-container`);
      const ps = new PerfectScrollbar(container, {
        suppressScrollY: true,
      });
    }

    // Activate in view on each item
    const items: any = elt.querySelectorAll(`.${cssClass}-item`);
    inView(`.${cssClass}`)
      .on('enter', ()=>{
        elt.classList.add('isInViewport');

        for (const item of items) {
          item.style.animationDelay = `${timing.params.slow / items.length * Array.prototype.indexOf.call(items, item)}ms`;
        }
      });
  }
};

export {
  style,
  script,
};
